import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { isOneHourViolation } from 'src/app/utils/utils.common';

@Directive({
  selector: '[appViolationBadge]'
})
export class ViolationBadgeDirective implements OnChanges {
  @Input() trip: any;
  @Input() timeZone: string;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['trip'] || changes['timeZone']) {
      const isViolation = isOneHourViolation(this.trip, this.timeZone);
      this.renderer.setProperty(
        this.el.nativeElement,
        'innerHTML',
        isViolation ? this.getBadgeHtml() : ''
      );
    }
  }

  private getBadgeHtml(): string {
    return `
      <span class="inline-flex gap-1 items-center rounded-md bg-green-100 px-1.5 py-0.5 text-[9px] font-medium text-main-dark">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="h-3 text-main-dark">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
        </svg>
        <span>1 Hour Exception</span>
      </span>
    `;
  }
}

